module.exports = __webpack_public_path__ + "assets/filter-1f60ba.svg";